import axios from 'axios';

const API_BASE_URL = 'https://events.tifrbng.res.in/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// API endpoints
export const eventsAPI = {
  getLatestEvents: () => api.get('/upcoming?format=json'),
  getLatestColloquia: () => api.get('/latest/colloquia/'),
  getAllEvents: () => api.get('/all-events'),
  getEventById: (id) => api.get(`/events/${id}/`), // Assuming you have this endpoint
};

export default api;
